"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const CowriterSearchResultRowData = (props) => {
    const { data, onSelectWriter } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, data === null || data === void 0 ? void 0 : data.map((cowriter) => (react_1.default.createElement("tr", { key: cowriter.ipId },
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: 'cowriter-data' },
                react_1.default.createElement("div", { className: 'cowriter-data-left' },
                    react_1.default.createElement("div", { className: 'cowriter-name-titles' },
                        react_1.default.createElement("span", { className: 'cowriter-name' }, cowriter.name),
                        react_1.default.createElement("div", { className: 'cowriter-ipi' },
                            react_1.default.createElement("span", null, "IPI:"),
                            " ",
                            cowriter.ipiNumber))),
                react_1.default.createElement("div", { className: 'cowriter-data-right' },
                    react_1.default.createElement("button", { className: 'songs-count-section', onClick: () => !!cowriter.worksCount && onSelectWriter(cowriter) },
                        react_1.default.createElement("span", { className: 'songs-count-left-section' },
                            react_1.default.createElement("span", { className: 'songs-count-value' }, cowriter.worksCount),
                            react_1.default.createElement("span", { className: 'songs-count-bottom-section' }, "Songs")),
                        react_1.default.createElement("img", { src: common_1.ICONS.chevron_right }))))))))));
};
exports.default = CowriterSearchResultRowData;
